 document.addEventListener('DOMContentLoaded', function () {
  const drawerOpeners = document.querySelectorAll('.product-drawer-opener');
  const newDrawers = document.querySelectorAll('.product-drawer');

  // Function to open a drawer
  function openDrawer(targetId) {
    const drawer = document.querySelector(targetId);
    if (drawer) {
      drawer.classList.add('active');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
    }
  }

  // Function to close a drawer
  function closeDrawer(drawer) {
    drawer.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  // Bind click events on openers
  drawerOpeners.forEach(opener => {
    const targetId = opener.getAttribute('data-drawer');
    const button = opener.querySelector('button');

    if (button && targetId) {
      button.addEventListener('click', function (e) {
        e.stopPropagation(); // Prevent triggering document click
        newDrawers.forEach(d => closeDrawer(d));
        openDrawer(targetId);
      });
    }
  });

  // Bind click events on close buttons
  newDrawers.forEach(drawer => {
    const closeBtn = drawer.querySelector('.product-drawer__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeDrawer(drawer);
      });
    }
  });

  // Handle ESC key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      newDrawers.forEach(drawer => closeDrawer(drawer));
    }
  });

  // Click outside to close
  document.addEventListener('click', function (e) {
    const isInsideDrawer = [...newDrawers].some(drawer => drawer.contains(e.target));
    const isOpener = [...drawerOpeners].some(opener => opener.contains(e.target));

    if (!isInsideDrawer && !isOpener) {
      newDrawers.forEach(drawer => closeDrawer(drawer));
    }
  });
});

// Move newDrawers to end of <body>
const newDrawers = document.querySelectorAll('.product-drawer');
newDrawers.forEach(drawer => {
  document.body.appendChild(drawer);

  document.addEventListener("DOMContentLoaded", function () {
    if (!document.querySelector(".drawer-overlay")) {
      const overlay = document.createElement("div");
      overlay.classList.add("drawer-overlay", "hidden");
      document.body.appendChild(overlay);
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    const overlay = document.querySelector(".drawer-overlay");

    if (!overlay) return;

    // Open drawer → show overlay
    document.querySelectorAll(".product-drawer-button.link").forEach(button => {
      button.addEventListener("click", function () {
        overlay.classList.remove("hidden");
      });
    });

    // Close drawer → hide overlay
    function hideOverlay() {
      overlay.classList.add("hidden");
    }

    overlay.addEventListener("click", hideOverlay);

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        hideOverlay();
      }
    });

    document.querySelectorAll(".product-drawer__close").forEach(closeBtn => {
      closeBtn.addEventListener("click", hideOverlay);
    });
  });

  /*document.addEventListener('DOMContentLoaded', function () {
  const target = document.querySelector('.product-form__input .select');
  const moveEl = document.querySelector('.grid__item > .product__info-container > div:has(.product-form > .form)');
  
  if (target && moveEl) {
    target.after(moveEl);
  }
});*/

document.querySelectorAll('.product-form__input .form__label').forEach(function(label) {
  if (label.textContent.trim() === 'Size') {
    label.classList.add('size-label');
  }
});

document.querySelectorAll('.product-drawer-button.link').forEach(function(el) {
  if (el.textContent.includes('STORLEKSGUIDE')) {
    el.classList.add('size-guide');
  }
});

const target = document.querySelector('.drawer-block:has(.size-guide)');
if (target) {
  target.classList.add('hide');
}

setTimeout(function () {
  const targetLabel = document.querySelector('.new-variant_cont');
  const sizeGuide = document.querySelector('.size-guide');

  if (targetLabel && sizeGuide) {
    targetLabel.appendChild(sizeGuide);
  }
}, 1500);

/*jQuery(document).ready(function () {
  jQuery('.read-more-button').on('click', function () {
    console.log('test truncate');
    jQuery('.product__info-container .product__description').toggleClass('expanded');
    jQuery(this).text(isExpanded ? 'Läs mer' : 'Visa mindre');
  });
});

const el = document.querySelector('.product__description');

  if (!el) return;

  // Only do this if not expanded
  if (!el.classList.contains('expanded')) {
    const isClamped = el.scrollHeight > el.clientHeight;

    if (!isClamped) {
      document.querySelector('.read-more-button').style.display = 'none';
    }
  }*/
});






var ur = window.location.href;
if(ur.includes('/collection')){
   setTimeout(function(){ 

}, 1000);
}


document.addEventListener('DOMContentLoaded', function () {
  function exitMegaLevel3(container) {
    if (!container) return;
    const list = container.querySelector('.mega-menu__list.is-level-3');
    if (list) list.classList.remove('is-level-3');
    container.querySelectorAll('.is-level-3-li-selected').forEach(function (li) {
      li.classList.remove('is-level-3-li-selected');
    });
    container.querySelectorAll('.is-level-3-selected').forEach(function (el) {
      el.classList.remove('is-level-3-selected');
    });
    container.classList.remove('is-level-3-pc');
  }

  document.querySelectorAll('.mega-menu__link--level-2.has-level-3').forEach(function (el) {
    el.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      const parentUl = el.closest('ul');
      const parentLi = el.closest('li');
      const parentC = el.closest('.mega-menu-list-links-container');
      const nextEl = el.nextElementSibling;
      const details = el.closest('details.mega-menu');

      if (parentUl) parentUl.classList.toggle('is-level-3');
      if (parentLi) parentLi.classList.toggle('is-level-3-li-selected');
      if (parentC) parentC.classList.toggle('is-level-3-pc');
      if (nextEl) nextEl.classList.toggle('is-level-3-selected');

      if (details) {
        details.setAttribute('open', '');
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.querySelectorAll('details.mega-menu').forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (!details.open) {
        exitMegaLevel3(details.querySelector('.mega-menu-list-links-container'));
      }
    });
  });
});

var ur = window.location.href;
if(ur.includes('/product')){
  document.addEventListener("DOMContentLoaded", function() {
const mainButton   = document.querySelector('.product__info-wrapper .product-form__buttons:not(.sticky-mobile)');
const stickyButton = document.querySelector('.product-form__buttons.sticky-mobile');

let overlappedOnce = false; // latch: only set after first actual overlap
const EPS = 55; // small buffer to avoid flicker; set to 0 for exact edges

function checkOverlap() {
  if (!mainButton || !stickyButton) return;

  const mr = mainButton.getBoundingClientRect();
  const sr = stickyButton.getBoundingClientRect();
  const vh = window.innerHeight || document.documentElement.clientHeight;

  const mainVisible = mr.top < vh && mr.bottom > 0;

  // true only when their boxes touch/overlap (with EPS)
  const isOverlapping =
    !(sr.bottom <= mr.top + EPS || sr.top >= mr.bottom - EPS);

  // arm the latch once we *actually* overlap
  if (isOverlapping) overlappedOnce = true;

  // reset the latch if the main button is no longer visible (either past or not reached yet)
  if (!mainVisible) overlappedOnce = false;

  // class ON only if we've overlapped at least once AND the main is still visible
  if (overlappedOnce && mainVisible) {
    document.body.classList.add('is-overlap');
  } else {
    document.body.classList.remove('is-overlap');
  }
}

window.addEventListener('scroll', checkOverlap, { passive: true });
window.addEventListener('resize', checkOverlap);
checkOverlap();


const mainQty   = document.querySelector('.product__info-wrapper .product-form__buttons:not(.sticky-mobile) .quantity__input');
const stickyQty = document.querySelector('.product-form__buttons.sticky-mobile .quantity__input');

if (mainQty && stickyQty) {
  function sync(from, to) {
    if (!from || !to) return;
    if (to.value !== from.value) {   // prevent infinite loop
      to.value = from.value;
      to.dispatchEvent(new Event('change', { bubbles: true })); // let Shopify listeners run
    }
  }

  mainQty.addEventListener('input', () => sync(mainQty, stickyQty));
  mainQty.addEventListener('change', () => sync(mainQty, stickyQty));

  stickyQty.addEventListener('input', () => sync(stickyQty, mainQty));
  stickyQty.addEventListener('change', () => sync(stickyQty, mainQty));
}

const mainSubmit   = document.querySelector('.product__info-wrapper .product-form__buttons:not(.sticky-mobile) .product-form__submit');
const stickySubmit = document.querySelector('.product-form__buttons.sticky-mobile .product-form__submit');

if (mainSubmit && stickySubmit) {
  stickySubmit.addEventListener('click', (e) => {
    e.preventDefault(); // stop sticky’s own form submit
    mainSubmit.click(); // trigger main button instead
  });
}


});

}
